// The single place that turns an internal page slug into a storefront URL, shared
// by the public site (SitePage) and the in-place editor (SiteEditor) so the
// address bar always reflects the open page identically in both modes.
//   • slug mode   — /g/:orgSlug (home) and /g/:orgSlug/:slug
//   • domain mode — a verified custom domain serving at "/" (home) and "/:slug"
// 'home' is the org root (no slug segment).
export function pageUrl(orgSlug: string, domainMode: boolean, slug: string): string {
  const s = slug || 'home';
  if (domainMode) return s === 'home' ? '/' : `/${s}`;
  return s === 'home' ? `/g/${orgSlug}` : `/g/${orgSlug}/${s}`;
}
